<template>
  <div class="calendar">
    <div class="header">
      <div class="flex-container">
        <SelectScaleType v-model="scaleType" :disabled="referencia === null" />
      </div>
      <SelectTime v-model="time" :disabled="referencia === null" />
    </div>

    <ul class="body">
      <li
        v-for="(item, index) in weekdayOrdered"
        :class="['cel header', {
          'avaliable': item.avaliable,
          'active': item.active,
          'selected': item.selected
        }]"
        :key="index"
        @click="activeCellByWeekday(item)"
      >
        {{ item.label }}
      </li>

      <li
        v-for="cel in cels"
        :key="cel.key"
        :class="[
          'cel',
          cel.isAvaliable ? 'avaliable' : '',
          cel.active ? 'active' : '',
          cel.selected ? 'selected' : ''
        ]"
        @click="selectDay(cel)"
      >
        <div class="title">
          {{ cel.day }}
        </div>
        <div class="content">
          <TimeCell
            v-show="cel.active"
            v-for="(time, index) in cel.times"
            :key="index"
            :time="time"
          />
        </div>
      </li>
    </ul>

    <div class="footer">
      <div class="controls">
        <span v-show="daySelected.isEmpty" class="info"
          >Selecione algum dia para visualizar os períodos</span
        >
        <div v-show="!daySelected.isEmpty">
          <label class="control-label">Dia: {{ daySelected.day }}</label>
          <label class="control-label">Períodos</label>
          <div class="times">
            <TimeSpan
              v-for="(item, index) in daySelected.times"
              :key="item.entrada + item.saida"
              :time="item"
              :click="() => removeTime(index)"
            />
          </div>
          <SelectTime v-model="daySelected.timeToAdd" />
          <button
            type="button"
            class="btn btn-primary btn-block"
            @click="addTime"
          >
            Adicionar Período
          </button>
        </div>
      </div>
      <div class="status">
        <span>Total de dias ativos: {{ totalDaysActive }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SelectScaleType from '@/components/Calendar/SelectScaleType'
import SelectTime from '@/components/Calendar/SelectTime'
import TimeSpan from '@/components/Calendar/TimeSpan'
import TimeCell from '@/components/Calendar/TimeCell'

import { parseTimeToInt } from '@/utils/times'
import { twoDigit } from '@/utils/strings'

export default {
  components: {
    SelectScaleType,
    SelectTime,
    TimeSpan,
    TimeCell
  },
  props: {
    language: {
      type: String,
      default: 'pt-BR'
    },
    firstWeekday: {
      type: Number,
      default: 1
    },
    value: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    referencia: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.generateCelsWeekday()
    this.generateAvaliableDates()
    this.generateCels()
    this.fillDaysInCels()
  },
  data() {
    return {
      scaleType: '',
      time: { entrada: '', saida: '' },
      weekdays: [],
      avaliableDates: [],
      cels: [],
      daySelected: {
        isEmpty: true,
        day: '',
        timeToAdd: { entrada: '', saida: '' },
        times: []
      }
    }
  },
  computed: {
    weekdayOrdered() {
      let list = []
      let sufix = []

      this.weekdays.forEach(i => {
        if (i.number >= this.firstWeekday) {
          list.push(i)
        } else {
          sufix.push(i)
        }
      })

      return [...list, ...sufix]
    },
    hasTimeEntrada() {
      const { entrada } = this.time
      return entrada !== ''
    },
    hasTimeSaida() {
      const { saida } = this.time
      return saida !== ''
    },
    hasTime() {
      return this.hasTimeEntrada || this.hasTimeSaida
    },
    totalDaysActive() {
      return this.cels.filter(c => c.active).length
    }
  },
  watch: {
    referencia() {
      this.generateAvaliableDates()
        this.generateCels()
        this.fillDaysInCels()
        this.resetControls()
        this.update()
    },
    scaleType(value) {
      this.generateCels()
      this.fillDaysInCels()
      this.resetTime()
      this.generateScale(value)

      this.weekdays.forEach(cell => cell.avaliable = value === '*')

      // if (this.hasTime) {
      //   this.setTimeInCells(this.time)
      // }
    },
    time: {
      handler(value) {
        // this.resetDays()
        this.generateScale(this.scaleType)
        this.setTimeInCells(value)
        this.update()
      },
      deep: true
    },
    totalDaysActive(value) {
      if (this.hasTime && value > 0) {
        this.update()
      }
    },
    disabled (value) {
      this.weekdays.forEach(cell => cell.avaliable = !value)


      const [{ weekday: weekdayStart }] = this.avaliableDates
      const startIndex = this.cels.findIndex(
        ({ weekday }) => weekday === weekdayStart
      )

      let index = startIndex
      this.avaliableDates.forEach(({ date }) => {
        const cell = this.cels[index++]
        cell.isAvaliable = !value
      })
    }
  },
  methods: {
    generateAvaliableDates() {
      const referencia = !this.referencia ? this.getReferenciaDefault() : this.referencia

      const year = referencia.substr(0,4)
      const month = referencia.substr(-2)
      let end = new Date(year, month - 1, 25)
      let start = new Date(end.getTime())
      this.avaliableDates = []

      start.setMonth(start.getMonth() - 1)
      start.setDate(26)

      let seek = new Date(start.getTime())
      seek.setHours(0)

      do {
        const date = new Date(seek.getTime())
        this.avaliableDates.push({
          date,
          weekday: date.getDay(),
          month: date.getMonth()
        })
        seek.setDate(seek.getDate() + 1)
      } while (seek <= end)
    },
    getReferenciaDefault() {
      const dateDefault = new Date()
      dateDefault.setMonth(dateDefault.getMonth() + 1)
      const year = dateDefault.toLocaleString("pt-BR", { year:'numeric' })
      const month = dateDefault.toLocaleString("pt-BR", { month: "2-digit" })

      return `${year}${month}`
    },  
    generateCelsWeekday() {
      for (let number = 0; number < 7; number++) {
        this.weekdays.push({
          label: this.getWeekdayLabelBy(number),
          number,
          avaliable: false,
          active: false,
          selected: false
        })
      }
    },
    generateCels() {
      const [{ weekday: startWeekday }] = this.avaliableDates
      const datesLength = this.avaliableDates.length
      let lenghtCels = 35

      if (
        (startWeekday === 6 && datesLength > 30) ||
        (startWeekday === 0 && datesLength > 29)
      ) {
        lenghtCels = 42
      }

      this.cels = []
      for (let index = 0; index < lenghtCels; index++) {
        const weekday = this.weekdayOrdered[index % 7].number
        this.cels.push({
          key: index + 7,
          day: '',
          month: '',
          year: '',
          yearMonth: '',
          weekday,
          isEven: false,
          isOdd: false,
          isWeekend: weekday === 6 || weekday === 0,
          isAvaliable: false,
          active: false,
          selected: false,
          info: '',
          times: this.hasTime ? [...this.time] : []
        })
      }
    },
    fillDaysInCels() {
      const [{ weekday: weekdayStart }] = this.avaliableDates
      const startIndex = this.cels.findIndex(
        ({ weekday }) => weekday === weekdayStart
      )

      let index = startIndex
      this.avaliableDates.forEach(({ date }) => {
        const cell = this.cels[index++]
        this.fillDayInCel(cell, date)
      })
    },
    fillDayInCel(cell, date) {
      const day = date.getDate()
      const isEven = date.getDate() % 2 === 0

      cell.date = date
      cell.day = day
      cell.month = date.getMonth()
      cell.year = date.getFullYear(),
      cell.yearMonth = parseInt(`${date.getFullYear()}${date.toLocaleDateString("PT-br", { month: '2-digit' })}`)
      cell.isEven = isEven
      cell.isOdd = !isEven
      cell.isAvaliable = true
    },
    getWeekdayLabelBy(weekdayNumber) {
      const date = new Date(2006, 0, 1)
      date.setDate(date.getDate() + weekdayNumber)

      return date
        .toLocaleString(this.language, { weekday: 'short' })
        .toUpperCase()
        .replace('.', '')
    },
    deactivateCells() {
      for (let index = 0; index < this.weekdays.length; index++) {
        this.weekdays[index].active = false
        this.weekdays[index].selected = false
      }
      for (let index = 0; index < this.cels.length; index++) {
        this.cels[index].active = false
        this.cels[index].selected = false
      }
    },
    generateScale(type) {
      this.deactivateCells()

      switch (type) {
        case 'adm':
          this.generateScaleAdm()
          break
        case 'par':
        case 'impar':
          this.generateScalePlantao(type)
          break
        default:
          this.$toastr.s(
            'Para plantão fixo clique no dia da semana para selecionar todos!'
          )
          break
      }
    },
    generateScaleAdm() {
      let cells = this.cels.filter(c => c.isAvaliable && !c.isWeekend)
      for (let index = 0; index < cells.length; index++) {
        cells[index].active = true
      }
    },
    generateScalePlantao(type) {
      const cellsAvaliable = this.cels.filter(c => c.isAvaliable)
      const condicao = type === 'par' ? 0 : 1

      // criando os indices das celulas que serão ativadas de acordo com a condição se é par ou impar
      const indexes = [...Array(cellsAvaliable.length).keys()].filter(k => { return  k % 2 === condicao })

      indexes.forEach(i => cellsAvaliable[i].active = true)
    },
    activeCellByWeekday(celWeekday) {
      const activeValue = !celWeekday.active

      // 1 caminhos ativar as celulas OK
      if (activeValue) {
        switch (this.getTimeType(this.time)) {
          // 1.1 ativar celulas com horarios normais OK
          case 'leaveOnDay':
            const cells = this.getCellsAvaliableByWeekday(celWeekday.number)
            cells.forEach(cell => {
              cell.active = true
              cell.times = [{ ...this.time }]
            })
            celWeekday.active = true
            break
          // 1.2 ativar celulas com horarios de saida no proximo dia OK
          case 'leaveOnNextDay':
            // 1.2.1 verificação se o dia da semana é o ultimo
            if (this.isLastWeekDay(celWeekday.number)) {
              // 1.2.1.1 se for não ativa e envia uma mensagem dizendo que para o horario de saida no próximo dia
              // não é possivel selecionar o ultimo dia da semana
              this.$toastr.e(
                'Não é possivel selecionar o ultimo dia da semana para adicionar horário com saida no proxímo dia!'
              )
              return
            }

            const cellsTimeIn = this.getCellsAvaliableByWeekday(
              celWeekday.number
            )

            const celWeekdayNextIndex =
              celWeekday.number === 6 ? 0 : celWeekday.number + 1
            const celWeekdayNext = this.weekdays.find(
              ({ number }) => number === celWeekdayNextIndex
            )
            const cellsTimeOut = this.getCellsAvaliableByWeekday(
              celWeekdayNext.number
            )

            cellsTimeIn.forEach(cell => {
              cell.active = true
              cell.times = [{ entrada: this.time.entrada, saida: '' }]
            })

            cellsTimeOut.forEach(cell => {
              cell.active = true
              cell.times = [{ entrada: '', saida: this.time.saida }]
            })

            celWeekday.active = true
            celWeekdayNext.active = true
            break
          default:
            break
        }
      }
      // 2 desativar celulas
      else {
        switch (this.getTimeType(this.time)) {
          // 2.1 desativar celulas com horarios normais OK
          case 'leaveOnDay':
            const cells = this.getCellsAvaliableByWeekday(celWeekday.number)
            cells.forEach(cell => {
              cell.active = false
              cell.times = []
            })
            celWeekday.active = false
            break
          // 2.1 desativar celulas com horarios de saida no proximo dia
          case 'leaveOnNextDay':
            const cells2 = this.getCellsAvaliableByWeekday(celWeekday.number)
            const time = cells2[0].times.find(
              ({ entrada, saida }) =>
                this.time.entrada === entrada || this.time.saida === saida
            )
            // criando uma lista de index da weekday para poder navegar entre as colunas calendário
            const weekdayIndexes = []
            for (var i = this.firstWeekday; i < this.weekdays.length; i++) {
              weekdayIndexes.push(this.weekdays[i].number)
            }

            // verificando a diferença entre os dois arrays
            const lastWeekday = this.weekdays.find(
              ({ number }) => !weekdayIndexes.includes(number)
            )
            weekdayIndexes.push(lastWeekday.number)

            const currentIndex = weekdayIndexes.findIndex(
              index => index === celWeekday.number
            )
            let celWeekdayNext = {}

            if (this.getTimeType(time) === 'timeIn') {
              celWeekdayNext = this.weekdays[weekdayIndexes[currentIndex + 1]]
            } else {
              celWeekdayNext = this.weekdays[weekdayIndexes[currentIndex - 1]]
            }

            const cellsNext = this.getCellsAvaliableByWeekday(
              celWeekdayNext.number
            )

            cells2.forEach(cell => {
              cell.active = false
              cell.times = []
            })

            cellsNext.forEach(cell => {
              cell.active = false
              cell.times = []
            })

            celWeekday.active = false
            celWeekdayNext.active = false
            break
          default:
            break
        }
      }
    },
    getCellsAvaliableByWeekday(weekday) {
      return this.cels.filter(
        cell => cell.isAvaliable && cell.weekday === weekday
      )
    },
    isLastWeekDay(weekday) {
      const lastWeekday = this.firstWeekday === 0 ? 6 : this.firstWeekday - 1
      return weekday === lastWeekday
    },
    selectDay(cel) {
      const { selected } = cel
      this.deselectAllCells()

      // deselecionar
      if (selected) {
        cel.selected = false
        cel.active = false
        cel.times = []
      }
      // selecionar
      else {
        cel.active = true
        cel.selected = true

        if (this.headerAvailableSelection) {
          cel.times = [{...this.time}]
        }

        this.daySelected.day = cel.day
        this.daySelected.times = cel.times
      }
      this.daySelected.isEmpty = selected
    },
    resetDays() {
      this.resetDaysActived()
      this.resetDaySelected()
    },
    resetDaysActived() {
      this.cels
        .filter(({ active }) => active)
        .forEach(item => (item.active = false))
    },
    resetDaySelected() {
      this.cels
        .filter(({ selected }) => selected)
        .forEach(item => (item.selected = false))
      this.daySelected = {
        isEmpty: true,
        day: '',
        timeToAdd: { entrada: '', saida: '' },
        times: []
      }
    },
    deselectAllCells() {
      const cellsSelected = this.cels.filter(c => c.selected)
      cellsSelected.forEach(c => (c.selected = false))
    },
    resetControls() {
      this.scaleType = ''
      this.resetTime()
    },
    resetTime() {
      this.time.entrada = ''
      this.time.saida = ''
    },
    setTimeInCells(time) {
      switch (this.getTimeType(time)) {
        case 'leaveOnDay':
          this.setTimeLeaveOnDayInCells(time)
          break
        case 'leaveOnNextDay':
          this.setTimeLeaveOnNextDayInCells(time)
          break
        default:
          break
      }
    },
    getTimeType({ entrada, saida }) {
      if (entrada === '' && saida === '') return ''
      if (entrada === '') return 'timeOut'
      if (saida === '') return 'timeIn'

      const entradaNumber = parseInt(entrada.replace(/\D/, ''))
      const saidaNumber = parseInt(saida.replace(/\D/, ''))

      if (entradaNumber < saidaNumber) return 'leaveOnDay'
      if (entradaNumber >= saidaNumber) return 'leaveOnNextDay'
    },
    setTimeLeaveOnDayInCells({ entrada, saida }) {
      if (entrada === '' || saida === '') return

      const cellsActives = this.cels.filter(({ active }) => active)
      cellsActives.forEach(cel => {
        cel.times = [{ entrada, saida }]
      })
    },
    setTimeLeaveOnNextDayInCells({ entrada, saida }) {
      const indexes = this.cels
        .map(({ active }, index) => ({ index, active }))
        .filter(item => item.active)
        .map(({ index }) => index)

      if (indexes.length > 0) {
        const [lastAvailableDate] = this.avaliableDates.reverse()
        indexes.forEach(index => {
          // verificar se é o ultimo dia da escala
          if (lastAvailableDate.date === this.cels[index].date) {
            // se for ignora a saida do próximo dia e adiciona no mesmo dia o ultimo horário
            this.cels[index].times = [{ entrada, saida: '' }]

            const nextDate = new Date(this.cels[index].date)
            nextDate.setDate(nextDate.getDate() + 1)

            this.fillDayInCel(this.cels[index + 1], nextDate)

            this.cels[index + 1].times = [{ entrada: '', saida }]
            this.cels[index + 1].active = true
            this.cels[index + 1].referencia = this.nextReferencia
          } else {
            // se não for adiciona a saida no próximo dia
            this.cels[index].times = [{ entrada, saida: '' }]
            this.cels[index + 1].times = [{ entrada: '', saida }]
            this.cels[index + 1].active = true
          }
        })
      }
    },
    addTime() {
      const { day, timeToAdd } = this.daySelected
      const lastIndex = this.avaliableDates.length - 1
      const lastAvailableDate = this.avaliableDates[lastIndex]

      timeToAdd.entrada = this.formatTime(timeToAdd.entrada)
      timeToAdd.saida = this.formatTime(timeToAdd.saida)

      // verifica se o dia selecionado é o ultimo da escala
      if (lastAvailableDate.date.getDate() === day) {
        // se for mudar a saida do time para as 23h59
        const { entrada, saida } = this.daySelected.timeToAdd

        if (saida < entrada) {
          this.daySelected.timeToAdd.saida = '23:59'  
        }

        this.addTimeLeaveOnDay()
        return
      }

      switch (this.getTimeType(timeToAdd)) {
        case 'leaveOnDay':
          this.addTimeLeaveOnDay()
          break
        case 'leaveOnNextDay':
          this.addTimeLeaveOnNextDay()
          break
        default:
          break
      }
    },
    formatTime(time) {
      if (time.length === 0) {
        return time
      }

      if (time.length === 2) {
        return `${time}h00`
      }

      return time
    },
    addTimeLeaveOnDay() {
      const { timeToAdd, times } = this.daySelected

      if (this.validTime(timeToAdd)) {
        this.daySelected.times.push(timeToAdd)
        this.daySelected.timeToAdd = { entrada: '', saida: '' }
        this.update()
      } else {
        this.$toastr.e(
          'Esse período é inválido, verifique se há algum conflito!'
        )
      }
    },
    addTimeLeaveOnNextDay() {
      const { day, timeToAdd } = this.daySelected
      const timeIn = { entrada: timeToAdd.entrada, saida: '' }
      const timeOut = { entrada: '', saida: timeToAdd.saida }
      const cellIn = this.cels.find(cell => cell.day === day)
      const cellNextIndex = this.cels.findIndex(
        cell => cell.key === cellIn.key + 1
      )

      const timesIn = cellIn.times
      if (!this.validTime(timeIn, timesIn)) {
        this.$toastr.e(
          `Esse período é inválido, verifique se há algum conflito no dia ${
            cellIn.day
          }!`
        )
        return
      }

      const timesOut = this.cels[cellNextIndex].times
      if (!this.validTime(timeOut, timesOut)) {
        this.$toastr.e(
          `Esse período é inválido, verifique se há algum conflito no dia ${
            this.cels[cellNextIndex].day
          }!`
        )
      }

      // add time
      this.daySelected.times.push(timeIn)
      this.cels[cellNextIndex].times.push(timeOut)

      this.cels[cellNextIndex].active = true
      this.daySelected.timeToAdd = { entrada: '', saida: '' }

      this.update()
    },
    activeCell(index, date) {
      this.fillDayInCel(this.cels[index], date)
      this.cels[index].isAvaliable = true
      this.cels[index].active = true
    },
    removeTime(index) {
      this.daySelected.times.splice(index, 1)
      this.update()
    },
    validTime(time, times) {
      let isValid = true

      if (!times) {
        times = this.daySelected.times
      }

      const timeNew = parseTimeToInt(time)

      let index = 0
      while (isValid && index < times.length) {
        const time = parseTimeToInt(times[index++])
        let timeIsBefore = false
        let timeIsAfter = false

        // verificar se o time é anterior
        if (
          typeof timeNew.saida === 'number' &&
          typeof time.entrada === 'number'
        ) {
          timeIsBefore = timeNew.saida <= time.entrada
        }

        // verificar se o time é posterior
        if (
          typeof timeNew.entrada === 'number' &&
          typeof time.saida === 'number'
        ) {
          timeIsAfter = timeNew.entrada >= time.saida
        }

        isValid = timeIsBefore || timeIsAfter
      }

      return isValid
    },
    update() {
      const { cels, referencia: refBase } = this

      // only days active and that contains times
      const dates = cels
        .filter(({ isAvaliable }) => isAvaliable)
        .map(({ date, referencia: refDay, times, active, selected }) => (
          {
            date,
            times, 
            active,
            selected, 
            referencia: !!refDay ? refDay : refBase,
        }))

      this.$emit('input', { referencia: refBase, dates })
    }
  }
}
</script>

<style scoped>
.calendar {
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 0.105em solid #c5c5c5;
  line-height: 1.5;
  border-radius: 8px;
  margin-bottom: 10px;
}

.calendar .header {
  padding: 20px;
}

.calendar .header .flex-container {
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
}

.calendar .header .flex-container div {
  flex: 1 1 200px;
  margin-right: 10px;
}

.calendar .header .flex-container div:last-child {
  margin-right: 0px;
}

@media screen and (max-width: 487px) {
  .calendar .header .flex-container div {
    margin-right: 0px;
  }
}

.calendar .header .title {
  padding: 15px;
  text-align: center;
  border-top: 1px solid #c5c5c5;
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
}

.calendar .body {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  padding: 0px;
  margin: 0px;
  clear: none;
}

.calendar .body .cel {
  font-size: 14px;
  font-weight: 500;
  color: #1a202c;
  padding: 8px 0px;
  text-align: center;
  list-style-type: none;
  border-top: 1px solid #c5c5c5;
}

.calendar .body .cel .title {
  text-align: center;
}

.calendar .body .cel .content {
  font-size: 11px;
  font-weight: none;
  text-align: center;
  color: #fff;
  min-height: 32px;
}

.calendar .body .cel.active {
  color: #fff;
  background-color: rgba(70, 140, 54, 0.8) !important;
}

.cel.avaliable:hover,
.cel.avaliable.active:hover,
.cel.avaliable.active.selected {
  cursor: pointer;
  color: #fff;
  transition: background-color 0.2s ease-out;
  background-color: rgba(70, 140, 54, 0.5) !important;
}

.calendar .body .cel:not(:nth-child(7n)) {
  border-right: 1px solid #c5c5c5;
}

.calendar .footer .controls,
.calendar .footer .status {
  box-sizing: border-box;
  border-top: 1px solid #c5c5c5;
  color: #1a202c;
  padding: 5px 15px;
}

.calendar .footer .controls span,
.calendar .footer .status span {
  color: #718096;
  font-weight: 500;
  margin-bottom: 0.75rem;
  font-style: italic;
}

.calendar .footer .controls label {
  display: block;
}

.calendar .footer .controls .times {
  display: flex;
  flex-flow: row wrap;
  flex-wrap: wrap;
  border: 1px solid #c5c5c5;
  border-radius: 4px;
  min-height: 75px;
  margin-bottom: 5px;
  padding: 10px 0px 0px 10px;
}

.calendar .footer .controls button:not(.close) {
  margin: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/index.vue